import Boto from 'components/corporatiu/Boto';
import styles from './premisludi.module.scss';
import Imatge from 'components/corporatiu/Imatge';

const PremisLudi = (props) => {
    const { titol, text, textBoto, route, imgFons } = props;
    return (
        <div className={styles.contentModul}>
            <div className={styles.modulPremisLudi} style={{ '--bg-imatge-butlleti': `url(${imgFons})` }}>
                <div className={styles.wrapper}>
                    <div className={styles.content}>
                        <div className={styles.logo}>
                            <Imatge src='/_resources/logos/premisludi.svg' width='119' height='36' alt='Premis Ludi' />
                        </div>
                        <h2 className={styles.titol}>{titol}</h2>
                        <p className={styles.text}>{text}</p>
                        <Boto
                            className={styles.boto}
                            text={textBoto}
                            route={route}
                            link='https://premisludi.cat/'
                            tema='ple3cat'
                            novaFinestra={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PremisLudi;
